import React from "react";

function Partners() {
  return (
    <div className="partners">
      <div className="tag_btn wow fadeInUp">Partnerships</div>
      <div className="t f_24 wow fadeInUp">Meet our partners</div>
      <div className="des wow fadeInUp">
        {" "}
        Our AI partners are trained with elite firms and partnered with
        prestigious schools
      </div>
      <div className="scroll_box wow fadeInUp mt-16">
        <div className="animate_box">
          <div className="flex_xb">
            <div className="pics">
              <div className="pic">
                <img src="./images/Parnters/1.svg.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/5.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/7.svg.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/4.webp" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/2.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/6.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/3.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/8.png" alt="" />
              </div>
            </div>
          </div>
          <div className="flex_xb">
            <div className="pics">
              <div className="pic">
                <img src="./images/Parnters/1.svg.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/5.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/7.svg.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/4.webp" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/2.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/6.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/3.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/8.png" alt="" />
              </div>
            </div>
          </div>
          <div className="flex_xb">
            <div className="pics">
              <div className="pic">
                <img src="./images/Parnters/1.svg.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/5.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/7.svg.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/4.webp" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/2.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/6.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/3.png" alt="" />
              </div>
              <div className="pic">
                <img src="./images/Parnters/8.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;
